export function CRUDth({ th }) {
    return (
        <th>{th}</th>
    )
}